import axios from "axios";
import * as Preferences from "./Preferences";

export const getInitialSetData = (langCode, callback) => {
  let svcUrl =
    Preferences.SERVER_BASE_URL + Preferences.INITIAL_SET_PARTITIONED_SUFFIX;

  console.log("Fetching INITIALSETDATA FROM: " + svcUrl);

  //zovi axios
  axios
    .post(svcUrl, {
      language: langCode
    })
    .then(response => {
      console.log("Received response!");
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};

export const getThirdSetData = (
  callback,
  odabraneKvote,
  drugeOklade,
  jezik,
  stampKData,
  stampOData,
  stampUData,
  stampUText,
  newExpanded,
  noveDrugeOklade,
  oldExpanded
) => {
  let svcUrl =
    Preferences.SERVER_BASE_URL + Preferences.THIRD_SET_PARTITIONED_SUFFIX;

  //console.log("Fetching THIRDSETDATA FROM: " + svcUrl);

  //zovi axios
  axios
    .post(svcUrl, {
      OdabeneKvote: odabraneKvote,
      drOklade: drugeOklade,
      language: jezik,
      maxUpdateStampKData: stampKData,
      maxUpdateStampOData: stampOData,
      maxUpdateStampUDat: stampUData,
      maxUpdateStampUText: stampUText,
      newExpanded: newExpanded,
      novedrOklade: noveDrugeOklade,
      oldExpanded: oldExpanded
    })
    .then(response => {
      //console.log("Received response!");
      if (callback) {
        callback(response.data);
      }
    })
    .catch(error => {
      console.log("Request error!");
      console.log("Desc: ", error);
      if (callback) {
        callback(null);
      }
    });
};



// WEBPACK FOOTER //
// ./src/Communication/BetRadarServicesHandler.js